import React, { useState, useEffect } from 'react'
import { Link, useOutletContext } from 'react-router-dom';
import { Alert, Badge, Button, Card, Col, Container, Form, Image, InputGroup, Placeholder, Row, Spinner, Stack } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/nl';
import Breadcrumbs from '../Components/Breadcrumbs';
import { includesNotCaseSensitive } from '../utils/jtrFunctions';
import { analytics } from '../utils/firebase';
import { logEvent } from 'firebase/analytics';


export default function Home(props) {
    const {routes, user, purchases, loading, series, setSeries, seriesLoading} = useOutletContext();
    const [search, setSearch] = useState("")

    // Track page view when component loads
    useEffect(() => {
        logEvent(analytics, 'page_view', {
            page_title: "Ukie's Academy - Home",
            page_location: window.location.href,
            content_type: 'home'
        });
    }, []);

    // Track search events
    const handleSearchChange = (e) => {
        const searchValue = e.target.value;
        setSearch(searchValue);
        
        // Track search events for queries longer than 2 characters
        if (searchValue.length >= 3) {
            logEvent(analytics, 'search', {
                search_term: searchValue,
                content_type: 'series'
            });
        }
    };

    // Track series card clicks
    const handleSeriesClick = (seriesItem) => {
        logEvent(analytics, 'select_content', {
            content_type: 'series',
            item_id: seriesItem.uuid,
            item_name: seriesItem.name,
            series_type: seriesItem.type,
            has_access: seriesItem.access,
            is_free: seriesItem.isFree,
            click_destination: seriesItem.access ? 'series_page' : 'external_link'
        });
    };

    return (
        <Stack>
            <div className="structure-fullwidth" style={{backgroundImage:"url('https://imagedelivery.net/rHj-gKo2iv8uX7Gew5qNsg/f07e0c75-4728-4c29-bed7-19b7530fed00/w=3840')",backgroundPosition:'50% 60%'}}>
                <div className="structure header-banner structure-1 lg:structure-2 items-end" style={{alignItems:'flex-end',height:'500px'}}>
                    <div className="component component-text white text-shadow">
                        <div className="preheader-text white">Ukie's Academy</div>
                        <div className="header-text">Online leeromgeving voor paardvriendelijke huisvesting</div>
                    </div>
                </div>
            </div>
            <Breadcrumbs routes={routes} user={user} series={series}/>
            
            <Container style={{position:'sticky',top:'64px',zIndex:'100',background:'white',borderBottom:'1px solid lightgray',maxWidth:'76rem',padding:'0'}}>
                <div className="component component-search" style={{padding:'1rem', display:'flex', justifyContent:'end', gap:'1rem',flexWrap:'wrap'}}>
                    <div style={{display:'flex',flexDirection:'column',gap:0,width:'100%'}}>
                        <form style={{alignItems:'end'}}>
                            <div className="eui-input-wrapper" style={{borderRadius:'0.375rem 0 0 0.375rem',width:'400px',maxWidth:'100%'}}>
                                <input className="eui-input" name="search" type="search" value={search} onChange={handleSearchChange}/>
                            </div>
                            <button type="submit" style={{height:'41.6px'}}> 
                                <span className="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#ffffff" fillRule="nonzero" opacity="0.8"></path>
                                            <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#ffffff" fillRule="nonzero"></path>
                                        </g>
                                    </svg>
                                </span> 
                            </button>
                        </form>
                    </div>
                </div>
            </Container>
            { !loading && !user &&
                <Row style={{padding:'1rem',marginBottom:'-2rem'}}>
                    <a href='https://www.ukies.nl/account/login' target='_parent' style={{padding:'0'}}>
                        <Alert variant='warning'>Je bent niet ingelogd, <b>log in</b> om toegang te krijgen tot jouw cursussen</Alert>     
                    </a>
                </Row>
            }
            { loading
                ?
                <Row gap={3} style={{gap:'2rem 0rem',padding:'2rem 0',position:'relative'}}>
                    { seriesLoading &&
                        <Col style={{display:'flex',flexDirection:'row', justifyContent:'center', alignItems:'center', gap:'1rem', padding:'1rem',position:'absolute',height:'73px',zIndex:'1000',top:'-74px',background:'#fff'}}>
                            <Spinner style={{color:'var(--ukies-dark-green)'}}/>
                            <div className='loading-message'>Cursussen worden geladen</div>
                        </Col> 
                    }
                    { ['','','','','',''].map((s, idx) => {
                        return(
                        <Col xs={12} md={6} lg={4} xl={3} key={idx} className='academy-col'>
                            <a href='#'>
                                <Card className='academy-card card-inactive'>
                                    <div style={{position:'relative'}}>
                                        <div style={{overflow:'hidden',borderTopLeftRadius:'calc(0.375rem - 1px)',borderTopRightRadius:'calc(0.375rem - 1px)'}}>
                                            <Placeholder as={'div'} className='card-img card-img-top thumbnail' style={{aspectRatio:'3 / 2'}} animation='glow'>
                                                <Placeholder xs={12} style={{height:'100%'}} />
                                            </Placeholder>
                                        </div>
                                        <Badge className='series-type-badge' bg="custom" style={{color:'#00000000'}}>Loading</Badge>
                                    </div>
                                    <Card.Body>
                                        <div className="component-text">
                                            <Placeholder as={Card.Title} className="header-text-small" style={{fontSize:'1.6rem',lineHeight:'1.6rem',padding:'0 0 0 0'}} animation="glow">
                                                <Placeholder xs={8} />
                                            </Placeholder>
                                            <Placeholder as={Card.Text} className="body-text-small" style={{fontSize:'0.75rem',fontStyle:'italic',marginBottom:'0.75rem',padding:'0rem 0.5rem 0rem 0.5rem'}} animation="glow">
                                                <Placeholder xs={6} />
                                            </Placeholder>                                            
                                            <Placeholder as={Card.Text} className="body-text-small" style={{fontSize:'0.75rem',fontStyle:'italic',marginBottom:'0.75rem',padding:'0rem 0.5rem 0rem 0.5rem'}} animation="glow">
                                                <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
                                                <Placeholder xs={6} /> <Placeholder xs={8} />
                                            </Placeholder>
                                        </div>
                                        <Placeholder as={Card.Text} className="body-text-small" style={{fontSize:'0.75rem',textAlign:'right',fontStyle:'italic',marginBottom:'0.75rem',display:'flex',flexDirection:'row',justifyContent:'space-between'}} animation="glow">
                                            <Placeholder xs={6} />
                                            <Placeholder xs={3} />
                                        </Placeholder>  
                                        <Placeholder as={'div'} animation="glow" style={{display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',padding:'1rem 0.5rem',margin:'0 -1rem -1rem -1rem',fontSize:'0.7rem', fontWeight:'bold',color:'#fff',backgroundColor:'#545454'}}>
                                            <Placeholder xs={10}  />
                                        </Placeholder>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>
                        )
                    }) }
                </Row>
                :
                <Row gap={3} style={{gap:'2rem 0rem',padding:'2rem 0'}}>
                    { series.filter((e) => (search.length < 3 || includesNotCaseSensitive(e.name,search) || includesNotCaseSensitive(e.shortDesc,search) || includesNotCaseSensitive(e.type,search) || e.tags.some(a => includesNotCaseSensitive(a.label,search)))).map((s, idx) => {
                        return(
                        <Col xs={12} md={6} lg={4} xl={3} key={s.uuid} className='academy-col'>
                            <Link to={s.access ? '/series?sid=' + s.uuid : s.alternativeLink.length > 0 ? s.alternativeLink : s.productLink} target={s.access ? undefined : '_parent'} onClick={() => handleSeriesClick(s)}>
                                <Card className={s.access ? 'academy-card' : 'academy-card card-inactive'}>
                                    <div style={{position:'relative'}}>
                                        <div className='thumbnail-container' style={{overflow:'hidden',borderTopLeftRadius:'calc(0.375rem - 1px)',borderTopRightRadius:'calc(0.375rem - 1px)'}}>
                                            <Card.Img className='thumbnail' variant="top" src={s.thumbnail}/>
                                        </div>
                                        <Badge className='series-type-badge' bg="custom">{s.type}</Badge>
                                    </div>
                                    <Card.Body>
                                        <div style={{display:'none', gap:'0.5rem',paddingBottom:'0.5rem'}}>
                                            { s.tags && s.tags.length > 0 && s.tags.map((tag, idx) => {
                                                return(<Badge key={idx} style={{backgroundColor:tag.color === 'normal' ? 'var(--ukies-light-green)' : 'var(--ukies-dark-orange)', fontSize:'0.75rem', fontWeight:'normal'}} bg="custom">{tag.label}</Badge>)
                                            })}
                                        </div>
                                        <div className="component-text">
                                            <Card.Title className="header-text-small" style={{fontSize:'1.6rem',lineHeight:'1.6rem',padding:'0 0 0 0'}}>{s.name}</Card.Title>
                                            <Card.Text as="div" className="body-text-small" style={{fontSize:'0.75rem',fontStyle:'italic',marginBottom:'0.75rem',padding:'0rem 0.5rem 0rem 0.5rem'}}>
                                                {s.contentType}
                                            </Card.Text>
                                            
                                            <Card.Text className="body-text-small justify" style={{fontSize:'0.8rem'}}>{s.shortDesc}</Card.Text>
                                        </div>
                                        <Card.Text as="div" className="body-text-small" style={{fontSize:'0.75rem',textAlign:'right',fontStyle:'italic',marginBottom:'0.75rem',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                            <div>
                                                {
                                                    s.moduleCount > 0 &&
                                                    <span>{s.moduleCount} module{s.moduleCount > 1 && 's'}</span>
                                                }
                                                {s.moduleCount > 0 && s.fileCount > 0 && ', '}
                                                {s.fileCount > 0 &&
                                                    <span>{s.fileCount} bestand{s.fileCount > 1 && 'en'}</span>
                                                }
                                            </div>
                                            <div>
                                                {moment.utc(s.length*1000).format('H') > 0 && moment.utc(s.length*1000).format('H') + 'u'} {moment.utc(s.length*1000).format('m')}m {moment.utc(s.length*1000).format('s')}s
                                            </div>
                                        </Card.Text>
                                        <div style={{display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',padding:'1rem 0.5rem',margin:'0 -1rem -1rem -1rem',fontSize:'0.7rem', fontWeight:'bold',color:'#fff',backgroundColor:s.access ? 'var(--ukies-light-green)' : '#545454'}}>
                                            { s.access
                                            ? s.isFree
                                                ? s.freeUntil && s.freeUntil.length > 0 
                                                    ? <span>Tot {(moment(s.freeUntil).format('LL'))} GRATIS</span>
                                                    : <span>Bekijk GRATIS deze {s.type.toLowerCase()}</span>
                                                : <span>Je hebt nog <span>{s.accessRemaining}</span> dagen toegang</span>
                                            : <span>Je hebt nog geen toegang tot deze {s.type.toLowerCase()}</span>
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        )
                    }) }
                </Row>
            }
        </Stack>
    );
}